import MuiTabContext, { TabContextProps } from '@mui/lab/TabContext';

export interface ITabContextProps extends TabContextProps {}

const TabContext = (props: ITabContextProps): JSX.Element => {
  return <MuiTabContext {...props} />;
};

export default TabContext;
